<template>
    <div class="container">
        <div class="row"></div>
        <vrm-form @submit="onSubmit">
            <div class="row">
                <div class="col-sm-12 col-md-10 col-md-offset-1">
                    <h1 class="vrm-page-title">
                        {{
                            $t('mfa.authorize_changes_title', {
                                i18nFallback:
                                    'Verify your identity to make twostep verification changes',
                            })
                        }}
                    </h1>
                    <p>
                        {{
                            $t('mfa.authorize_changes_explanation', {
                                i18nFallback:
                                    'Please verify your identity to make changes to your two-step verification settings.',
                            })
                        }}
                    </p>
                    <p v-if="loading">
                        {{
                            $t('mfa.authorize_changes_loading', {
                                i18nFallback: 'Checking security settings...',
                            })
                        }}
                    </p>
                    <p v-else-if="error">
                        {{
                            $t('mfa.authorize_changes_error', {
                                i18nFallback: 'Failed to load two-step verification settings',
                            })
                        }}
                    </p>
                </div>
            </div>
            <template v-if="!loading && !error">
                <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-4 col-md-offset-1">
                        <vrm-text-field
                            v-if="isPassword"
                            v-model="token"
                            :title="
                                $t('mfa.authorize_changes_password', { i18nFallback: 'Password' })
                            "
                            type="password"
                            name="current_password"
                            autocomplete="current_password"
                            :disabled="busy"
                            required
                        />
                        <vrm-text-field
                            v-else
                            v-model="token"
                            :title="
                                $t('mfa.authorize_changes_token', {
                                    i18nFallback: 'Twostep verification code',
                                })
                            "
                            type="text"
                            name="one-time-code"
                            autocomplete="one-time-code"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            required
                            :disabled="busy"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-9 col-md-offset-1">
                        <div class="vrm-form__fieldset-item">
                            <button
                                type="submit"
                                class="sg-btn sg-blue pull-right"
                                :disabled="busy"
                            >
                                {{ $t('mfa.authorize_changes_verify', { i18nFallback: 'Verify' }) }}
                            </button>
                        </div>
                    </div>
                </div>
            </template>
        </vrm-form>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularRoute, ngInject } from '@/vue/decorators/angular-interop';
import VrmForm from '@/vue/components/forms/VrmForm';
import VrmTextField from '@/vue/components/forms/VrmTextField';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    components: { VrmTextField, VrmForm },
})
@AngularRoute('base.profile.twofactor.authorize', '/authorize-changes')
@AngularLocaleBundle('mfa')
export default class AuthorizeChanges extends Vue {
    token = '';

    loading = false;
    busy = false;
    error = false;
    mfaMode = null;

    get isPassword() {
        return this.mfaMode === 'password';
    }

    get isSms() {
        return this.mfaMode === 'sms';
    }

    get isMobile() {
        return this.mfaMode === 'mobile';
    }

    @ngInject()
    LoginService;

    async created() {
        this.loading = true;
        try {
            /** @type ProtectedAccessStartResult */
            const result = await this.$store.dispatch('MfaService/protectedAccessStart');
            if (result.success) {
                this.error = false;
                this.mfaMode = result.mfaMode;
            } else {
                this.error = true;
            }
        } finally {
            this.loading = false;
        }
    }

    async onSubmit() {
        this.busy = true;
        try {
            /** @type ProtectedAccessVerifyResult */
            const result = await this.$store.dispatch('MfaService/protectedAccessVerify', [
                this.token,
            ]);
            if (result.success) {
                this.$router.push('base.profile.twofactor');
            }
        } finally {
            this.busy = false;
        }
    }
}
</script>
